import { useEffect } from 'react'
import { getSlot, sammioSlotId } from 'lib/alma/alma'

export const useAlmaSammio = () => {
    useEffect(() => {
        getSlot(sammioSlotId) // fetch Alma Sammio
    }, [])

    return null
}
